import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";
import PayeeStatusUpsert from "./upsert/PayeeStatusUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function PayeeStatus(param: any) {

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);
  const [PayeeStatus, SetPayeeStatus] = useState<any>([]);
  const [editingOn, setEditingOn] = useState(false);

  useEffect(() => {
    if (param.activeTab === "Payee Status") {
      PayeeStatusSelect()
    }
  }, [param]);

  const PayeeStatusSelect = () => {
    var payload = {}
    systemListingService.statusPayeeList(payload).then((res: any) => { SetPayeeStatus(res) });
  }

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }

  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deletestatusPayee(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Payee Status delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const slider_handler = (e: any, selectData: any) => {

    if (e.target.type == "checkbox") {

      selectData[e?.target?.name] = selectData[e?.target?.name] == 1 ? 0 : 1

      systemListingService.saveStatusAccountExt(selectData).then((repond: any) => {
        PayeeStatusSelect();
      })
    }
  }

  return (
    <div className="content-card ws-12">

      <div className="ptl pbl ws-12">
        <span className="text-bold">Payee Status</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}>{editingOn ? "Edit Mode: On" : "Edit Mode: Off"}</button>

        <div className=" ws-12 mt">
          <button className="icon-btn primary height35 pull-right fill" type="button" disabled={!editingOn} onClick={() => openAddDrawer({})}  >Add Payee Status </button>
          <button className="btn-save-table hide" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }} >Save Changes </button>
        </div>

      </div>

      <div className="ws-12 allowHscroll allowVscroll">
        <table className={editingOn ? "editing-on newTable" : " newTable"}>
          <thead>
            <tr>
              <th className=" forceSingleLine">Status ID</th>
              <th className="forceSingleLine">Status Name</th>
              <th className=" forceSingleLine">Status Code</th>
              <th className=" forceSingleLine">Rec MYN</th>
              <th className=" forceSingleLine">Publ</th>
              <th className=" forceSingleLine">Mech</th>
              <th className=" forceSingleLine">Approval</th>
              <th className=" forceSingleLine">Control Rpt</th>
              <th className=" forceSingleLine">Email</th>
              <th className=" forceSingleLine">Auto LTD</th>
              <th className="forceSingleLine" style={{ width: "17%" }}>Operations</th>
            </tr>
          </thead>

          <tbody>
            {PayeeStatus.map((row: any) => (
              <tr key={row.id}>
                <td>{row.payeeStatusUseID}</td>
                <td>
                  <span style={{
                    background: CommonUtilities.lookUpTypeList('payeeStatusName', row.payeeStatusName, 'bgColor'),
                    color: CommonUtilities.lookUpTypeList('payeeStatusName', row.payeeStatusName, 'fontColor'),
                    borderRadius: "4px"
                  }} className="pm forceSingleLine">
                    {row.payeeStatusName}
                  </span>

                </td>
                <td>{row.payeeStatusShortCode}</td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="mechYN" checked={row?.mechYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.mechYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.mechYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>

                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="publYN" checked={row?.publYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.publYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.publYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="mechYN" checked={row?.mechYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.mechYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.mechYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="approvalYN" checked={row?.approvalYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.approvalYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.approvalYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="controlRptYN" checked={row?.controlRptYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.controlRptYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.controlRptYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="emailYN" checked={row?.emailYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.emailYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.emailYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="autoLTD" checked={row?.autoLTD === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.autoLTD === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.autoLTD === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                  <div className="width225">

                    <button className={`icon-btn info ${row.isDefault == 1 ? "fill" : ""}`} type="button" disabled={!editingOn} >Default  </button>
                    <button className="icon-btn edit" title="Edit " type="button" onClick={() => openAddDrawer(row)} disabled={!editingOn}><i className="icon-pencil"></i> </button>
                    <button className="icon-btn delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}>
                      <i className="icon-trash"> </i>
                    </button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <PayeeStatusUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected payee status " + deleteData?.payeeStatusName} onChange={deleteConfirmation} />
          }
        })()
      }

    </div>
  );
};